import {HealthReportLastNDaysPage} from './health-report-last-n-days';

function HealthReportLast7DaysPage(props: object) {
    return (
        <HealthReportLastNDaysPage {...props} nbDays={7} />
    );
}

export {HealthReportLast7DaysPage};
